var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "brief-content", class: `brief-content--${_vm.variant}` },
    [
      _c(
        "div",
        {
          staticClass: "brief-content__card",
          class: { "brief-content__card--boxed": _vm.showMeta },
        },
        [
          _c("div", { staticClass: "brief-content__intro" }, [
            _c("div", { staticClass: "brief-content__title" }, [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.brief.title || "Untitled brief") +
                  "\n      "
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "brief-content__owner" }, [
              _vm._v("\n        " + _vm._s(_vm.ownerLabel) + "\n      "),
            ]),
          ]),
          _vm._v(" "),
          _vm.showMeta
            ? _c("div", { staticClass: "brief-content__meta" }, [
                _c("div", [
                  _c("div", { staticClass: "brief-content__meta-label" }, [
                    _vm._v("\n          Assignee\n        "),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "brief-content__meta-value" }, [
                    _vm._v(
                      "\n          " + _vm._s(_vm.ownerLabel) + "\n        "
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", [
                  _c("div", { staticClass: "brief-content__meta-label" }, [
                    _vm._v("\n          Due\n        "),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "brief-content__meta-value" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.formatDate(_vm.brief.delivery_date)) +
                        "\n        "
                    ),
                  ]),
                ]),
              ])
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "brief-content__sections" },
        [
          _vm.brief.summary
            ? _c("div", { staticClass: "brief-content__section" }, [
                _c("div", { staticClass: "brief-content__label" }, [
                  _vm._v("\n        Summary\n      "),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "brief-content__body" }, [
                  _vm._v("\n        " + _vm._s(_vm.brief.summary) + "\n      "),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_vm.proseSections, function (section) {
            return _c(
              "div",
              {
                key: _vm.sectionKey(section),
                staticClass: "brief-content__section",
              },
              [
                _c("div", { staticClass: "brief-content__label" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.sectionLabel(section)) +
                      "\n      "
                  ),
                ]),
                _vm._v(" "),
                _c("RichTextDisplay", {
                  staticClass: "brief-content__body",
                  attrs: { html: section.content, "show-image-actions": "" },
                }),
              ],
              1
            )
          }),
          _vm._v(" "),
          _vm.imageSections.length
            ? _c("div", { staticClass: "brief-content__section" }, [
                _c("div", { staticClass: "brief-content__label" }, [
                  _vm._v("\n        Images requested\n      "),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "brief-content__images" },
                  _vm._l(_vm.imageSections, function (section) {
                    return _c(
                      "div",
                      {
                        key: _vm.sectionKey(section),
                        staticClass: "brief-content__image",
                      },
                      [
                        !_vm.hasDirection(section)
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "brief-content__image-toggle brief-content__image-toggle--static",
                              },
                              [
                                _c(
                                  "span",
                                  { staticClass: "brief-content__image-name" },
                                  [_vm._v(_vm._s(_vm.sectionLabel(section)))]
                                ),
                              ]
                            )
                          : [
                              _c(
                                "button",
                                {
                                  staticClass: "brief-content__image-toggle",
                                  attrs: {
                                    type: "button",
                                    "aria-expanded": _vm.isImageOpen(section)
                                      ? "true"
                                      : "false",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.toggleImageSection(section)
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "brief-content__image-name",
                                    },
                                    [_vm._v(_vm._s(_vm.sectionLabel(section)))]
                                  ),
                                  _vm._v(" "),
                                  _c("BriefDetailIcon", {
                                    staticClass: "brief-content__image-chevron",
                                    attrs: {
                                      name: _vm.isImageOpen(section)
                                        ? "chevron-up"
                                        : "chevron-down",
                                      size: "sm",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.isImageOpen(section)
                                ? _c("RichTextDisplay", {
                                    staticClass:
                                      "brief-content__body brief-content__image-body",
                                    attrs: {
                                      html: section.content,
                                      "show-image-actions": "",
                                    },
                                  })
                                : _vm._e(),
                            ],
                      ],
                      2
                    )
                  }),
                  0
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.references.length
            ? _c("div", { staticClass: "brief-content__section" }, [
                _c("div", { staticClass: "brief-content__label" }, [
                  _vm._v("\n        References\n      "),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "brief-content__refs" },
                  _vm._l(_vm.references, function (ref) {
                    return _c(
                      "div",
                      {
                        key: ref.id,
                        staticClass: "brief-content__ref",
                        class: {
                          "brief-content__ref--file": _vm.showsAsFile(ref),
                        },
                      },
                      [
                        _vm.showsAsImage(ref)
                          ? _c("img", {
                              staticClass: "brief-content__ref-img",
                              attrs: {
                                src: _vm.referenceImgSrc(ref),
                                alt: ref.name || "",
                              },
                              on: {
                                error: function ($event) {
                                  return _vm.onReferenceImgError(ref)
                                },
                              },
                            })
                          : _vm.showsAsVideo(ref)
                          ? _c("video", {
                              staticClass: "brief-content__ref-img",
                              attrs: {
                                src: ref.url,
                                muted: "",
                                playsinline: "",
                              },
                              domProps: { muted: true },
                              on: {
                                error: function ($event) {
                                  return _vm.markReferenceUnrenderable(ref)
                                },
                              },
                            })
                          : _c(
                              "a",
                              {
                                staticClass: "brief-content__ref-file",
                                attrs: {
                                  href: ref.url,
                                  target: "_blank",
                                  rel: "noopener noreferrer",
                                  "aria-label": `Open ${ref.name || "file"}`,
                                },
                              },
                              [
                                _c("span", {
                                  staticClass: "brief-content__ref-file-icon",
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.referenceFileIconMarkup(ref)
                                    ),
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass: "brief-content__ref-file-name",
                                  },
                                  [_vm._v(_vm._s(ref.name))]
                                ),
                              ]
                            ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "brief-content__ref-actions" },
                          [
                            !_vm.showsAsFile(ref)
                              ? _c(
                                  "button",
                                  {
                                    staticClass: "brief-content__ref-action",
                                    attrs: {
                                      type: "button",
                                      "aria-label": "View larger",
                                      title: "View larger",
                                    },
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.previewReference(ref)
                                      },
                                    },
                                  },
                                  [
                                    _c("BriefDetailIcon", {
                                      attrs: { name: "search", size: "sm" },
                                    }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "brief-content__ref-action",
                                attrs: {
                                  type: "button",
                                  "aria-label": `Download ${
                                    ref.name || "file"
                                  }`,
                                  title: "Download",
                                },
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.downloadReference(ref)
                                  },
                                },
                              },
                              [
                                _c("BriefDetailIcon", {
                                  attrs: { name: "download", size: "sm" },
                                }),
                              ],
                              1
                            ),
                          ]
                        ),
                      ]
                    )
                  }),
                  0
                ),
              ])
            : _vm._e(),
        ],
        2
      ),
      _vm._v(" "),
      _c("PreviewFileModal", { ref: "preview" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }